<template>
  <div :class="$style.pricing_stub">
    <div :class="$style.head_section">
      <div :class="$style.welcome_title">
        {{ locale('reports_pricing_stub_title') }}
        <div class="pricing-title-container">
          {{ locale(planTitle) }}
        </div>
      </div>
      <div
        :class="$style.description"
        v-html="locale('reports_pricing_stub_description')"
      />
      <div
        v-if="isOwner"
        :class="$style.upgrade_button"
      >
        <vgp-button
          class="change-view-btn"
          type="primary"
          small
          :label="locale('upgrade_rate_btn')"
          @onClick="upgradeClick"
        />
      </div>
    </div>

    <div :class="$style.demo_video">
      <video-component
        :video-url="'https://cdn.ganttpro.com/statics/media/videos/reports/StubForReportsSection.mp4'"
      />
    </div>
  </div>
</template>

<script>

import { getPlansObj } from '../../../helpers/pricingHelper';
import plansModel from '../../../models/plans';

export default {
  name: 'ReportsPricingStub',
  props: {
    planTitle: { type: String, required: true, default: 'base' },
    isOwner: { type: Boolean, required: true, default: false },
  },
  data() {
    return {
      locale: __,
    };
  },
  methods: {
    upgradeClick() {
      const newPlanObj = getPlansObj('reports');
      const userPlan = plansModel.getPlanInfo();

      userExtAnalytics.log('pricing_deadlock_reached', { type: 'reports' });
      this.$store.commit('paymentClient/showUpgradePopup', {
        show: true,
        mode: 'change-plan',
        newPlan: newPlanObj,
      });
    },
  },
};
</script>

<style module src='./style.less'></style>
<style src="./pricing.less"></style>
